import { Layout } from '@/components/Common/Layout';
import { PLUM_EMERGENCY_HELPLINE_NUMBER } from '@/constants';
import { useAppContext } from '@/context/AppContext';
import useClaimCreateStore, {
  EClaimCreateFlowSteps,
} from '@/store/claimCreateStore';
import { EClaimType } from '@/types';
import { get } from 'lodash';
import { useEffect } from 'react';
import { twConfig } from 'ui/ds/utils/getConfig';
import { HealthIdInProcess } from 'ui/icons';
import { Button } from 'ui/mobile-ds';
import { ArrowForward } from 'ui/mobile-ds/icons';

const OrgUnderEnrollment = () => {
  const setCurrentStep = useClaimCreateStore((state) => state.setCurrentStep);
  const formState = useClaimCreateStore((state) => state.formState);
  const memberDetails = useClaimCreateStore((state) => state.memberDetails);

  useEffect(() => {
    window?.NativeBridge?.onLoadComplete?.();
  }, []);

  const { isWebView, homepageData } = useAppContext();
  const CONTACT_NUMBER =
    homepageData?.sos?.supportContactNumber ??
    PLUM_EMERGENCY_HELPLINE_NUMBER.split('-').join(' ');

  const allowClaimFiling =
    formState.typeOfClaim === EClaimType.REIMBURSEMENT &&
    memberDetails.length > 0;

  const handleFileClaim = () => {
    setCurrentStep(EClaimCreateFlowSteps.TREATMENT_DETAILS);
  };

  return (
    <Layout.Main
      headerProps={{
        onBack: () => {
          if (isWebView) {
            window?.NativeBridge?.onNativeClose?.();
          } else {
            setCurrentStep(EClaimCreateFlowSteps.SELECT_CLAIM_TYPE);
          }
        },
      }}
    >
      {({ getDimensions }) => {
        const footerDimensions = getDimensions('claims-footer');
        return (
          <div
            className="flex flex-col flex-1 h-full"
            style={{
              paddingBottom: footerDimensions.height,
            }}
          >
            <div className="flex flex-col items-center w-auto h-full my-auto ml-0 md:ml-0 lg:ml-[-72px]">
              <div className="flex flex-col items-center w-full max-w-[480px] my-auto gap-4">
                <HealthIdInProcess className="w-[120px] h-[120px]" />
                <div className="flex flex-col items-center gap-2">
                  <p className="text-2xl text-center text-gray-800 font-bold leading-8">
                    Enrollment in progress
                  </p>
                  <p className="text-center text-gray-500 text-base leading-[160%]">
                    Your org is under enrollment. You can raise a claim after
                    the enrollment period ends
                  </p>
                </div>
                <div className="mt-4 px-8">
                  <p className="text-center text-gray-500 leading-[160%]">
                    In case of any urgent support, reach out to us at&nbsp;
                    <span className="text-gray-600 font-semibold leading-[160%] block">
                      {CONTACT_NUMBER}
                    </span>
                  </p>
                </div>
                {allowClaimFiling && (
                  <Button
                    intent="secondary"
                    className="bg-transparent text-gray-500 border-gray-200 border rounded-lg mt-10"
                    onClick={handleFileClaim}
                  >
                    File claim for previous policy&nbsp;
                    <ArrowForward
                      color={get(twConfig, 'theme.colors.gray[500]')}
                    />
                  </Button>
                )}
              </div>
            </div>
          </div>
        );
      }}
    </Layout.Main>
  );
};

export default OrgUnderEnrollment;
